export const ENABLE_PULL_TO_REFRESH = false;
export const SHOULD_DISPLAY_ICON = false;
export const SHOULD_USE_SECONDARY_VARIANT = true;
